const actionTypeIdentifier = '970C81C5-2AD7-4EFF-BA97-2166FB755232'; // to generate open ssms run select newid()

//location form actions
export const setOtherRequestOptions = `SET-WIRELESS-OTHER-REQUEST-OTHER-OPTIONS-${actionTypeIdentifier}`;
export const setSubscriptionDetails = `SET-WIRELESS-OTHER-SUBSCRIPTION-DETAILS-${actionTypeIdentifier}`;
export const setFormSubmitted = `SET-WIRELESS-OTHER-FORM-SUBMITTED-${actionTypeIdentifier}`;

export const setFormLoading = `SET-WIRELESS-OTHER-REQUEST-FORM-LOADING-${actionTypeIdentifier}`;
export const setResetLoading = `SET-WIRELESS-OTHER-REQUEST-RESET-LOADING-${actionTypeIdentifier}`;


export const wirelessOtherModel = {
    circuitCode: ''
    , circuitId: 0
    , otherRequestTypeId: ''
    , otherRequestDetails: ''
}
